import React from 'react'

import * as S from './styles'

interface IPageTitleProps {
	text?: string
	children?: React.ReactNode
	style?: React.CSSProperties
}

const PageTitle = ({ text, children, style }: IPageTitleProps) => (
	<S.Grid container direction="row" style={style}>
		{text && <S.Title variant="h1">{text}</S.Title>}
		{children}
	</S.Grid>
)

export { PageTitle }
